import __vue_normalize__ from '../../../../common/temp/node_modules/.pnpm/registry.npmjs.org/vue-runtime-helpers/1.1.2/node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"M14.614 23.401L2.575 11.351a1.96 1.96 0 1 1 2.772-2.775l10.656 10.66 10.65-10.66a1.955 1.955 0 0 1 2.772 0 1.96 1.96 0 0 1 0 2.774l-12.04 12.051c-.38.381-.884.572-1.382.572-.504 0-1.008-.19-1.389-.572z"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
